import { PayloadContent } from '../payload-content.model';
import { NotificationSetting } from './notification-setting.model';

export class NotificationsProfile extends PayloadContent {
  constructor() {
    super();

    this.payloadType = 'com.apple.notificationsettings';
  }

  /**
   * Required. An array of dictionaries, each of which specifies notification settings for one bundle identifier.
   */
  public notificationSettings = new Array<NotificationSetting>();
}
